import React, { useState, useEffect } from 'react';
import authService from './api-authorization/AuthorizeService'
import axios from 'axios'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { Link } from "react-router-dom";
import { useConfirm } from "material-ui-confirm";

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

export default function SearchLogs() {
    const [token, setToken] = useState("");
    const [days, setDays] = useState(1);
    const [status, setStatus] = useState("");
    const [appData, setAppData] = useState([]);
    const [loading, setLoading] = useState(false);
    const confirm = useConfirm();
    const apiPath = '/api/SearchLogs?days=';

    const columns = [
        {
            name: '',
            label: '',
            options: {
                filter: false,
                display: true,
                viewColumns: false,
                customBodyRender: (value, tableMeta, update) => {
                    let rowIndex = Number(tableMeta.rowIndex) + 1;
                    return (
                        <div style={{ textAlign: "right" }}><span>{rowIndex}</span></div>
                    )
                }
            }
        },
        {
            name: "searchTime",
            label: "Search Time",
            options: {
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{ textAlign: "left" }}>{(new Date(value + "Z")).toLocaleString()}</div>
                )
            }
        },
        {
            name: "searchText",
            label: "Search Text",
            options: {
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "exactMatch",
            label: "Exact Match",
            options: {
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{ textAlign: "left" }}>{value? "True": "False"}</div>
                )
            }
        },
        {
            name: "found",
            label: "Results",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "searchByName",
            label: "Searcher",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let record = appData[tableMeta.currentTableData[tableMeta.rowIndex].index];
                    let idType = record.searchByFIDEId > 0 ? "FIDE" : "USCF";
                    let id = record.searchByFIDEId > 0 ? record.searchByFIDEId : record.searchByUSCFId;
                    return (
                        //<div style={{ textAlign: "left" }}>
                        //    {record.searchByUSCFId != -1 ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + record.searchByUSCFId} target='_blank' rel='noreferrer'>{value}</a>) :
                        //        (record.searchByFIDEId != -1 ? (<a href={'https://ratings.fide.com/profile/' + record.searchByFIDEId} target='_blank' rel='noreferrer'>{value}</a>) : value)}
                        //</div>
                        <div style={{ textAlign: "left" }}>
                            {record.searchByUSCFId != -1 ? (<Link target="_blank" to={'/players/details?idtype=USCF&id=' + record.searchByUSCFId} className="button">{value}</Link>) :
                                (record.searchByFIDEId != -1 ? (<Link target="_blank" to={'/players/details?idtype=FIDE&id=' + record.searchByFIDEId} className="button">{value}</Link>) : value)}
                        </div>
                    );
                }
            }
        },
        {
            name: "searchByFIDEId",
            label: "FIDE ID",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{ textAlign: "center" }}>{value != -1 ? (<a href={'https://ratings.fide.com/profile/' + value} target='_blank' rel='noreferrer'>{value}</a>) : (-1)}</div>
                )
            }
        },
        {
            name: "searchByUSCFId",
            label: "USCF ID",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{ textAlign: "center" }}>{value != -1 ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + value} target='_blank' rel='noreferrer'>{value}</a>) : (-1)}</div>
                )
            }
        },
        {
            name: "searchFromIP",
            label: "Search IP",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true
            }
        },
    ];

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        expandableRows: false,
        selectableRows: 'none',
        expandableRowsOnClick: false,
        expandableRowsHeader: false,
        download: false,
        print: false,
        rowsPerPage: 10,
        rowsPerPageOptions: [5, 10, 15, 25, 50, 100, 200],
        jumpToPage: true,
        fixedHeaderOptions: {
            xAxis: true,
            yAxis: true
        },
        resizableColumns: false,
        isRowExpandable: (dataIndex, expandedRows) => {
            // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
            if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
                return false;
            return true;
        },
        rowsExpanded: [],
        onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
            console.log(curExpanded, allExpanded, rowsExpanded),
    };

    const theme = createTheme({
        overrides: {
            MUIDataTableSelectCell: {
                expandDisabled: {
                    // Soft hide the button.
                    visibility: 'hidden',
                },
            },
        },
    });

    const components = {
        ExpandButton: function (props) {
            return <ExpandButton {...props} />;
        },
    };

    useEffect(async () => {
        setToken(await authService.getAccessToken());
    }, []); //Runs only on the first render

    const getAppData = async (e, playerName) => {
        e.preventDefault();
        setToken(await authService.getAccessToken());
        var headers = {
            headers: { 'Authorization': `Bearer ${token}` }
        }

        axios.get(apiPath + days, headers).then((response) => {
            setAppData(response.data);
            setLoading(false);
            setStatus("");
        }).catch((error) => {
            setLoading(false);
            setStatus("Error - Please check log for details.");
            console.log(JSON.stringify(error));
        });
    };

    const deleteAppData = async (e, day, confirm) => {
        e.preventDefault();
        confirm({ description: `This will permanently delete search logs for the past ${day} days.`, confirmationText: 'Delete' })
            .then(
                async () => {
                    setToken(await authService.getAccessToken());
                    var headers = {
                        headers: { 'Authorization': `Bearer ${token}` }
                    }

                    axios.delete('/api/SearchLogs/' + days, headers).then((response) => {
                        setAppData(response.data);
                        setLoading(false);
                        setStatus("");
                    }).catch((error) => {
                        setLoading(false);
                        setStatus("Error - Please check log for details.");
                        console.log(JSON.stringify(error));
                    })
                }
        )
            .catch(() => {
                console.log("Deletion cancelled.");
                setLoading(false);
            }
            );

    };

    return (
        <Box sx={{ pt: 2, pb:2 }}>
            <Grid container direction="row" rowSpacing={1} columnSpacing={1} align-items="flex-end">
            <Grid item xs={12} lg={7} >
                <TextField
                    size="small"
                    fullWidth
                    id="outlined-number"
                    label={"Search In The Past " + days +" Day(s)"}
                    type="number"
                    inputProps={{min:1,max:365 }}
                    InputLabelProps={{
                        shrink: true
                    }}
                    value={days}
                    onChange={(e) => setDays(e.target.value)}
                />
            </Grid>
            <Grid item xs={6} lg={3}>
                <Stack spacing={1} direction="row" justifyContent="end">
                        <LoadingButton fullWidth onClick={async (e) => { e.preventDefault(); await setLoading(true); await getAppData(e, days); }} loading={loading} loadingIndicator="Loading..." variant="contained">Show Search Logs</LoadingButton>
                        {/*<Button variant="outlined" onClick={async (e) => { e.preventDefault(); await setAppData([]); await setStatus(""); }}>{"Clear"}</Button>*/}
                </Stack>
            </Grid>
            <Grid item xs={6} lg={2}>
                    <Stack spacing={1} direction="row" justifyContent="end">
                        <LoadingButton fullWidth onClick={async (e) => { e.preventDefault(); await setLoading(true); await deleteAppData(e, days, confirm); }} loading={loading} loadingIndicator="Loading..." variant="contained" color="error">Clear All Logs</LoadingButton>
                </Stack>
            </Grid>
            <Grid item xs={12}>
                <div>
                    <label style={{ color: 'red' }}>{status}</label>
                </div>
            </Grid>
                {/*{appData.length > 0 &&*/}
                {appData.length > 0 &&
                    <Grid item xs={12}>
                        <CacheProvider value={muiCache}>
                            <ThemeProvider theme={theme}>
                                <MUIDataTable
                                /*title={appData.length + " downloads in the past " + days + " day(s)"}*/
                                title={
                                    <div>
                                        <Button variant="contained" color="secondary"
                                            onClick={async (e) => { e.preventDefault(); await setAppData([]); /*await setSelectedUser(); await setSearchString("")*/ }}>
                                            {"Clear Results (" + appData.length + ")"}
                                        </Button>
                                    </div>
                                }
                                    data={appData}
                                    columns={columns}
                                    options={options}
                                    components={components}
                            />

                            </ThemeProvider>
                        </CacheProvider>
                    </Grid>
                }
            </Grid>
            
        </Box>
    )
}
